/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react"
import { GameStates } from "components/gameBoard/interfaces"
import { GameBoardWrapper, UpperContent } from "./GameBoardStyled"
import { ResultComponent } from "components/result/Result"
import { Credentials } from "./cardStack/credentials/Credentials"
import CardStackComponent from "./cardStack/CardsStack"
import useSound from "use-sound"
import cardDealSFX from "lib/audio/globals/cardDealSFX.mp3"

export const GameBoardComponent = ({
  bankerStake,
  playerStake,
  tieStake,
  gameInfo,
  betInfo,
  isGameActive,
  deal,
  bankerCards,
  playerCards,
  showResult,
  dealOut,
  audio,
}: GameStates): JSX.Element => {
  const { currency, precision } = gameInfo
  const [dealedCards, setdealedCards] = useState<number>(0)
  const [playcardDealSFX] = useSound(cardDealSFX, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })
  useEffect(() => {
    bankerCards.length && isGameActive && timerFunc()
  }, [bankerCards])

  useEffect(() => {
    deal && audio.sound && playcardDealSFX()
  }, [dealedCards])

  const timerFunc = (time?: number, counter?: number) => {
    const intervalTime = time ? time : 400
    const cardsSum = playerCards.length + bankerCards.length
    let x = counter ? counter : 0
    const soundInterval = setInterval(() => {
      x++
      setdealedCards(x)
      if (x >= cardsSum) {
        clearInterval(soundInterval)
        return
      }
      if (cardsSum > 4 && x === 4) {
        clearInterval(soundInterval)
        timerFunc(1400, 4)
      } else if (cardsSum > 4 && x === 5) {
        clearInterval(soundInterval)
        timerFunc(400, 5)
      }
    }, intervalTime)
  }

  return (
    <GameBoardWrapper isGameActive={isGameActive}>
      <div>
        <UpperContent>
          {+tieStake > 0 ? (
            <Credentials
              name='tie'
              isGameActive={isGameActive}
              stake={tieStake}
              currency={currency}
              precision={precision}
              bankerLength={bankerCards.length}
            />
          ) : (
            <div />
          )}
          <CardStackComponent
            name='banker'
            win={betInfo.win_seat === "BANKER"}
            deal={deal}
            dealOut={dealOut}
            isGameActive={isGameActive}
            gameInfo={gameInfo}
            stake={bankerStake}
            point={betInfo.banker?.point || "0"}
            points={betInfo.banker?.points || []}
            result={betInfo.win_seat || ""}
            cards={bankerCards}
            showResult={showResult}
          />
        </UpperContent>
        <CardStackComponent
          name={"player"}
          bankerLength={bankerCards.length}
          win={betInfo.win_seat === "PLAYER"}
          deal={deal}
          dealOut={dealOut}
          isGameActive={isGameActive}
          gameInfo={gameInfo}
          stake={playerStake}
          point={betInfo.player?.point || "0"}
          points={betInfo.player?.points || []}
          result={betInfo.win_seat || ""}
          cards={playerCards}
          showResult={showResult}
        />
      </div>
      <ResultComponent
        betInfo={betInfo}
        showResult={showResult}
        dealOut={dealOut}
        audio={audio}
        currency={currency}
        marginTop='69px'
        marginBottom='35px'
        precision={precision}
      />
    </GameBoardWrapper>
  )
}
